import { cloneElement, Children, isValidElement } from 'react';

import type { TCarousel } from '../models';

export function renderCards({ children }: TCarousel, cardWidths?: number[]): JSX.Element[] {
    return (
        Children.map(children, (value, index) => {
            if (!isValidElement(value)) return null;
            const props = {
                ...value.props,
                key: index,
            };

            if (cardWidths) {
                Object.assign(props, { width: cardWidths[index] });
            }

            return cloneElement(value, props);
        }) || []
    );
}
